export default __webpack_public_path__ + "static/media/vip-leaf-left.cd9b5be2.svg";